import { render, staticRenderFns } from "./MultiAttachment.vue?vue&type=template&id=5e06dcf4&scoped=true&"
import script from "./MultiAttachment.vue?vue&type=script&lang=js&"
export * from "./MultiAttachment.vue?vue&type=script&lang=js&"
import style0 from "./MultiAttachment.vue?vue&type=style&index=0&id=5e06dcf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06dcf4",
  null
  
)

export default component.exports